import { STRING } from 'resources'

import { SectionTitle, SectionSubTitle, StyledButton } from './styles'

const ButtonsSection = () => {
  const doNothing = () => null

  return (
    <>
      <SectionTitle>{STRING.designSystemScreen.buttons}</SectionTitle>
      <SectionSubTitle>Primary Buttons</SectionSubTitle>
      <StyledButton buttonText="Primary button" onPress={doNothing} />
      <StyledButton onPress={doNothing}>Primary button with children</StyledButton>
      <StyledButton buttonText="Primary button with icon" iconName="fingerprint" onPress={doNothing} />
      <StyledButton buttonText="Primary button with arrow" withArrow onPress={doNothing} />
      <StyledButton
        buttonText="Primary button with icon and arrow"
        iconName="fingerprint"
        withArrow
        onPress={doNothing}
      />
      <StyledButton buttonText="Primary button loading" isLoading onPress={doNothing} />
      <StyledButton buttonText="Primary button disabled" disabled onPress={doNothing} />
      <StyledButton
        buttonText="Primary button disabled with icon"
        disabled
        iconName="fingerprint"
        onPress={doNothing}
      />
      <StyledButton buttonText="Primary button disabled with arrow" disabled withArrow onPress={doNothing} />

      <SectionSubTitle>Secondary Buttons</SectionSubTitle>
      <StyledButton buttonText="Secondary button" variant="secondary" onPress={doNothing} />
      <StyledButton
        buttonText="Secondary button with icon"
        variant="secondary"
        iconName="fingerprint"
        onPress={doNothing}
      />
      <StyledButton buttonText="Secondary button with arrow" variant="secondary" withArrow onPress={doNothing} />
      <StyledButton buttonText="Secondary button loading" variant="secondary" isLoading onPress={doNothing} />
      <StyledButton buttonText="Secondary button disabled" variant="secondary" disabled onPress={doNothing} />
      <StyledButton
        buttonText="Secondary button disabled with icon"
        variant="secondary"
        disabled
        iconName="fingerprint"
        onPress={doNothing}
      />
      <StyledButton
        buttonText="Secondary button disabled with arrow"
        variant="secondary"
        disabled
        withArrow
        onPress={doNothing}
      />

      <SectionSubTitle>Transparent Buttons</SectionSubTitle>
      <StyledButton buttonText="Transparent button" variant="transparent" onPress={doNothing} />
      <StyledButton
        buttonText="Transparent button with icon"
        variant="transparent"
        iconName="fingerprint"
        onPress={doNothing}
      />
      <StyledButton buttonText="Transparent button with arrow" variant="transparent" withArrow onPress={doNothing} />
      <StyledButton buttonText="Transparent button loading" variant="transparent" isLoading onPress={doNothing} />
      <StyledButton buttonText="Transparent button disabled" variant="transparent" disabled onPress={doNothing} />
      <StyledButton
        buttonText="Transparent button disabled with icon"
        variant="transparent"
        disabled
        iconName="fingerprint"
        onPress={doNothing}
      />
      <StyledButton
        buttonText="Transparent button disabled with arrow"
        variant="transparent"
        disabled
        withArrow
        onPress={doNothing}
      />
    </>
  )
}

export default ButtonsSection
